<mat-form-field class="example-full-width" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" (focus)="optionsActivated = true" />
  <button matSuffix mat-icon-button color="primary" type="button"
    *ngIf="allowCreate && showCreateButton"
    aria-label="Создать поставщика" title="Создать поставщика"
    [disabled]="createDisabled || control.disabled || creating"
    (click)="$event.stopPropagation(); createProvider()">
    <mat-icon>add</mat-icon>
  </button>
  <mat-autocomplete
    #auto="matAutocomplete"
    class="providerSelectorPanel"
    [panelWidth]="panelWidth"
    [displayWith]="displayProperty"
    (optionSelected)="onSelect($event)"
  >
    <ng-container *ngIf="!loadOnFocus || optionsActivated">
    <ng-container *ngIf="filteredSuggestions | async as visibleSuggestions">
      <mat-optgroup *ngIf="visibleSuggestions.length" label="Есть у поставщиков">
        <mat-option
          class="providerSuggestionOption"
          *ngFor="let suggestion of visibleSuggestions"
          [value]="suggestion"
        >
          <span class="providerSuggestion">
            <span class="providerSuggestionName">{{ suggestion.provider_name }}</span>
            <span class="providerSuggestionMeta">
              <span
                class="providerSuggestionAvailability"
                [attr.data-availability]="suggestion.quantity > 0 ? suggestion.availability_kind : null"
              >
                {{ getSuggestionAvailability(suggestion) }}
              </span>
              <span class="providerSuggestionEta" *ngIf="suggestion.arrival_label">
                {{ suggestion.arrival_label }}
              </span>
              <span class="providerSuggestionPrice" *ngIf="suggestion.purchase_price">
                закупка {{ suggestion.purchase_price | number: '1.0-2' }} ₴
              </span>
            </span>
          </span>
        </mat-option>
      </mat-optgroup>

      <mat-option *ngIf="suggestionsLoading" class="providerSuggestionLoading" disabled>
        Проверяем наличие и цены…
      </mat-option>

      <ng-container *ngIf="filteredOptions | async as visibleProviders">
        <mat-optgroup
          *ngIf="visibleSuggestions.length && visibleProviders.length"
          label="Остальные поставщики"
        >
          <mat-option *ngFor="let provider of visibleProviders" [value]="provider">
            {{ provider.description }}
            {{ balance ? ': ' + supportService.formatMoney(provider.balance) : '' }}
          </mat-option>
        </mat-optgroup>

        <ng-container *ngIf="!visibleSuggestions.length">
          <mat-option *ngFor="let provider of visibleProviders" [value]="provider">
            {{ provider.description }}
            {{ balance ? ': ' + supportService.formatMoney(provider.balance) : '' }}
          </mat-option>
        </ng-container>

        <mat-option
          *ngIf="
            allowCreate && createName && !createDisabled && !creating &&
            !suggestionsLoading &&
            !visibleSuggestions.length &&
            !visibleProviders.length
          "
          [value]="control.value"
        >
          Создать поставщика «{{ createName }}»
        </mat-option>
      </ng-container>
    </ng-container>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
